@import "../../../globalStyles/commons";


:host {
  display: none;
}

:host([active]) {
  display: block;
  flex: 1;
}
